module.exports = __webpack_public_path__ + "assets/img/ico-2.a8cf5f9d.webp";